import { render, staticRenderFns } from "./DealerLocator.vue?vue&type=template&id=5d96149a&"
import script from "./DealerLocator.vue?vue&type=script&lang=js&"
export * from "./DealerLocator.vue?vue&type=script&lang=js&"
import style0 from "./DealerLocator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DealerLocator.vue"
export default component.exports